import React from 'react';
import Header from '../components/organisms/Header';
import Footer from '../components/organisms/Footer';
import { NavLink } from '../types';
import './FAQPage.css';

const FAQPage: React.FC = () => {
  const navLinks: NavLink[] = [
    { text: 'Home', href: '/' },
    { text: 'Catalog', href: '/catalog' },
    { text: 'Contact', href: '/contact' }
  ];

  const handleEmailSubmit = (email: string): void => {
    console.log('Email subscription:', email);
    // Handle email subscription logic here
  };

  const handleFollowShop = (): void => {
    console.log('Follow on shop clicked');
    // Handle follow shop logic here
  };

  const faqSections = [
    {
      title: 'Ordering and Customization',
      questions: [
        {
          question: 'How far in advance should I place my order?',
          answer: 'We recommend placing your order at least 4 days in advance, and 1 week for custom designs. For larger events, a month\'s notice is ideal.'
        },
        {
          question: 'Do you offer same-day or last-minute orders?',
          answer: 'We do our best to accommodate last-minute orders depending on availability, but it\'s always best to contact us as early as possible.'
        },
        {
          question: 'Can I customize my cake design?',
          answer: 'Absolutely! We love working with you to create a design that fits your vision.'
        },
        {
          question: 'What flavors and designs do you offer?',
          answer: 'We have a wide variety of flavors and designs, from classic vanilla and chocolate to more elaborate custom creations. We can also create themed cakes.'
        },
        {
          question: 'Do you accommodate special dietary needs or allergies?',
          answer: 'Unfortunately, we do not cater to specific dietary requirements or allergies. Our cakes may contain gluten, milk, eggs, and other allergens. If you have any concerns, please feel free to reach out for more information.'
        },
        {
          question: 'Can I get a tasting session before placing a large order?',
          answer: 'Yes, we offer tasting options for wedding cakes.'
        }
      ]
    },
    {
      title: 'Delivery and Collection',
      questions: [
        {
          question: 'What are your delivery options and fees?',
          answer: 'We offer delivery within Dublin only, and a starting fee of €10 based on your location. For deliveries beyond that, please contact us for a quote.'
        },
        {
          question: 'What is your delivery area?',
          answer: 'We deliver within Dublin only.'
        },
        {
          question: 'Can I pick up my cake myself?',
          answer: 'Absolutely! You\'re welcome to pick up your cake, you can select the collection option when selecting your product and the collection details will be sent on once your order has been confirmed.'
        },
        {
          question: 'What do I do if I need to change the delivery time?',
          answer: 'Please let us know at least 24 hours in advance, and we\'ll do our best to accommodate the new time.'
        },
        {
          question: 'What should I do if my cake is damaged upon delivery?',
          answer: 'Please contact us immediately. We will assess the situation and provide a solution, whether it\'s a replacement or a refund.'
        }
      ]
    },
    {
      title: 'Payment and Cancellations',
      questions: [
        {
          question: 'Do you require a deposit for orders?',
          answer: 'No, we charge the full cost at check-out. We only require deposit for wedding orders.'
        },
        {
          question: 'What is your cancellation policy?',
          answer: 'Cancellations made at least 14 days before the delivery date will receive a full refund. After that, the deposit is non-refundable.'
        },
        {
          question: 'How do I pay for my order?',
          answer: 'We accept all major credit and debit cards, PayPal, and apple or google pay at checkout.'
        }
      ]
    },
    {
      title: 'Storage and Freshness',
      questions: [
        {
          question: 'How should I store my cake once I receive it?',
          answer: 'Cakes should be stored in a cool, dry place. Most cakes are best kept in the refrigerator if not consumed within a few hours. We have care guides included with every purchase.'
        },
        {
          question: 'How long will my cake stay fresh?',
          answer: 'Generally, cakes stay fresh for up to five days if stored properly in the refrigerator.'
        },
        {
          question: 'How do I care for my cake if it\'s for an outdoor event?',
          answer: 'Keep the cake in a shaded, cool area and avoid direct sunlight. If possible, have it stored in a cooler until just before serving.'
        }
      ]
    },
    {
      title: 'General Inquiries',
      questions: [
        {
          question: 'Do you provide cake toppers or decorations?',
          answer: 'Yes, we can provide custom cake toppers and decorations, or you can bring your own.'
        }
      ]
    }
  ];

  return (
    <div className="App">
      <Header navLinks={navLinks} />
      
      <main className="faq-main">
        <div className="faq-container">
          <div className="faq-header">
            <h1>Frequently Asked Questions</h1>
            <p className="faq-intro">
              Find answers to common questions about ordering, delivery, and more.
            </p>
          </div>

          <div className="faq-content">
            {faqSections.map((section, sectionIndex) => (
              <section key={sectionIndex} className="faq-section">
                <h2 className="faq-section-title">{section.title}</h2>
                <div className="faq-questions">
                  {section.questions.map((faq, questionIndex) => (
                    <div key={questionIndex} className="faq-item">
                      <h3 className="faq-question">{faq.question}</h3>
                      <p className="faq-answer">{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      
      <Footer 
        onEmailSubmit={handleEmailSubmit}
        onFollowShop={handleFollowShop}
      />
    </div>
  );
};

export default FAQPage;
